import $ from 'jquery';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-tool-tip]';
const PLUGIN_NAME = 'toolTip';
const TIP_ACTIVE_CLASSNAME = 'active';

class ToolTip {
	constructor(element, options) {
        this.$element = $(element);
        this.watch();
    }

    watch() {
        var mod = this;
        this.$element.on('click', function () {
            if (mod.$element.hasClass(TIP_ACTIVE_CLASSNAME)) {
                mod.$element.removeClass(TIP_ACTIVE_CLASSNAME);
            } else {
                mod.$element.addClass(TIP_ACTIVE_CLASSNAME);
            }
        });
    }
}

ToolTip.DEFAULTS = {};
plugin(PLUGIN_NAME, ToolTip);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/forms/tooltip.js